/* eslint-disable import/no-default-export, import/order, max-lines, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
// @ts-expect-error TS(6133): 'React' is declared but its value is never read.
import React from "react";
import { useDtfStore } from "./store";
import UseSvg from "common/vue/components/UseSvg.react.vue";
import { cn } from "tailwind-variants";
import "./ArtworkAlert.scss";

export default function ArtworkAlert({ children, ...restProps }: any) {
  const store = useDtfStore();

  function showNewGangSheetErrorMessage() {
    // @ts-expect-error TS(4111): Property 'showNewGangSheetErrorMessage' comes from... Remove this comment to see the full error message
    return store.showNewGangSheetErrorMessage;
  }

  return (
    <div {...restProps} className={cn("artwork-alert scope-dc7770ac", restProps?.className)}>
      <div
        className={cn(
          "scope-dc7770ac",
          showNewGangSheetErrorMessage()
            ? "artwork-alert__new-container"
            : "artwork-alert__container"
        )}
      >
        {!showNewGangSheetErrorMessage() ? (
          <div className="artwork-alert__icon scope-dc7770ac">
            <UseSvg
              className="artwork-alert__warning scope-dc7770ac"
              icon="warning"
              data-testid="artwork-alert-warning"
            />
          </div>
        ) : null}
        <div className="artwork-alert__message scope-dc7770ac">{children}</div>
      </div>
    </div>
  );
}
